
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 19a1.5 1.5 0 01-1.5-1.5c0-1.938 1.352-3.709 3.909-5.118 1.905-1.05 2.891-3.131 2.51-5.301-.352-2.003-1.997-3.648-4-4-1.445-.254-2.865.092-4.001.974a5.003 5.003 0 00-1.922 3.559 1.5 1.5 0 11-2.991-.227 8.005 8.005 0 013.073-5.7C8.89.278 11.149-.275 13.437.126c3.224.566 5.871 3.213 6.437 6.437.597 3.399-1.018 6.794-4.017 8.447-1.476.813-2.357 1.744-2.357 2.49A1.5 1.5 0 0112 19zm-1.5 3.5a1.5 1.5 0 103.001-.001 1.5 1.5 0 00-3.001.001z"}})])
          )
        }
      }
    